import { aerosoftCrjTemplate } from "../../data/templates/aircraft/aerosoft-crj";
import { fbwA32NXTemplate } from "../../data/templates/aircraft/fbw-a32nx";
import { fbwA32NXExpandedTemplate } from "../../data/templates/aircraft/fbw-a32nx-expanded";
import { fbwA380xTemplate } from "../../data/templates/aircraft/fbw-a380x";
import { fenixA319Template } from "../../data/templates/aircraft/fenix-a319";
import { fenixA320Template } from "../../data/templates/aircraft/fenix-a320";
import { fenixA321Template } from "../../data/templates/aircraft/fenix-a321";
import { horizon787Template } from "../../data/templates/aircraft/horizon-787";
import { inibuildsA300Template } from "../../data/templates/aircraft/inibuilds-a300";
import { a330Template } from "../../data/templates/aircraft/inibuilds-a330";
import { a340Template } from "../../data/templates/aircraft/inibuilds-a340";
import { a350Template } from "../../data/templates/aircraft/inibuilds-a350";
import { pmdg737Template } from "../../data/templates/aircraft/pmdg-737";
import { pmdg777Template } from "../../data/templates/aircraft/pmdg-777";
import { aPilotsLifeTemplate } from "../../data/templates/software/apl";
import { fs2crewTemplate } from "../../data/templates/software/fs2crew";
import { fsltlTemplate } from "../../data/templates/software/fsltl";
import { pacxTemplate } from "../../data/templates/software/pacx";
import { pilot2AtcTemplate } from "../../data/templates/software/pilot2atc";
import { selfLoadingCargoTemplate } from "../../data/templates/software/selfLoadingCargo";
import { vatsimTemplate } from "../../data/templates/software/vatsim";
import {
  AddonTemplate,
  AircraftAddonTemplate,
  SoftwareAddonTemplate,
} from "../model/addonTemplate";

export const aircraftAddonTemplates: AircraftAddonTemplate[] = [
  fenixA320Template,
  pmdg737Template,
  fbwA32NXTemplate,
  fbwA380xTemplate,
  pmdg777Template,
  fbwA32NXExpandedTemplate,
  inibuildsA300Template,
  a330Template,
  a340Template,
  a350Template,
  aerosoftCrjTemplate,
  fenixA319Template,
  fenixA321Template,
  horizon787Template,
];

export const softwareAddonTemplates: SoftwareAddonTemplate[] = [
  pilot2AtcTemplate,
  vatsimTemplate,
  fsltlTemplate,
  aPilotsLifeTemplate,
  fs2crewTemplate,
  selfLoadingCargoTemplate,
  pacxTemplate,
];

export const allAddonTemplates = [...aircraftAddonTemplates, ...softwareAddonTemplates];

export const showcaseAddons: AddonTemplate[] = [
  fenixA320Template,
  pmdg737Template,
  pmdg777Template,
  fbwA32NXTemplate,
  fbwA380xTemplate,
  a350Template,
  a340Template,
  aerosoftCrjTemplate,
  a330Template,
  inibuildsA300Template,
];
